<template>
  <card class="text-left" :header-classes="{ 'text-right': $rtl.isRTL }">
    <template slot="header">
      <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
        <h6 class="title d-inline">{{ $t('operatorAssignees.title') }} ({{ tableData.length }})</h6>
        <manage-operator-assignees
          v-if="$auth.can({assigned_operator: 'create'}, 'permissions')"
          :operator-id="$route.params.id"></manage-operator-assignees>
      </div>
    </template>
    <div v-loading="loading" ref="tableContainer" class="table-full-width table-responsive assignees-table"
         :style="{maxHeight: maxHeight}">
      <base-table :data="tableData" thead-classes="text-primary">
        <template slot="columns" slot-scope="{ columns }">
          <th>{{ $t('system_account.details.username') }}</th>
          <th>{{ $t('operatorAssignees.details.fullName') }}</th>
          <th>{{ $t('system_account.details.email') }}</th>
          <th></th>
        </template>

        <template slot-scope="{ row }">
          <td>{{ row.username }}</td>
          <td>{{ row.first_name }} {{ row.last_name }}</td>
          <td><span v-if="row.email">{{ row.email }}</span></td>
          <td class="td-actions text-right">
            <el-tooltip v-if="$auth.can({assigned_operator: 'delete'}, 'permissions')"
                        :content="$t('operatorAssignees.assigneeRemoveHint')"
                        effect="light" :open-delay="300" placement="top">
              <base-button icon round simple type="danger" size="sm" @click.native="handleDelete(row)">
                <i class="tim-icons icon-simple-remove"></i>
              </base-button>
            </el-tooltip>
          </td>
        </template>
      </base-table>
    </div>
  </card>
</template>
<script>

import {mapActions, mapState} from "vuex";
import {BaseTable} from '@/components';
import OperatorDetails from "src/components/Operator/OperatorDetails";
import ManageOperatorAssignees from "./ManageOperatorAssignees";

export default {
  name: 'operator-assignees-view',
  components: {
    BaseTable,
    ManageOperatorAssignees,
    OperatorDetails,
  },
  data() {
    return {
      visibleRows: 6,
      maxHeight: 'none',
    }
  },
  computed: {
    ...mapState({
      loading: state => state.operator_assignees.loading,
      tableData: state => state.operator_assignees.data,
      error: state => state.operator_assignees.error,
    }),
  },
  methods: {
    ...mapActions(['LoadOperatorAssignees', 'DeleteOperatorAssignee']),
    updateMaxHeight: function () {
      const container = this.$refs.tableContainer
      const rows = container ? container.querySelectorAll('tbody tr') : []
      if (rows.length <= this.visibleRows) {
        this.maxHeight = 'none'
        return
      }
      const head = container.querySelector('thead')
      let height = head ? head.offsetHeight : 0
      for (let i = 0; i < this.visibleRows; i++) {
        height += rows[i].offsetHeight
      }
      this.maxHeight = height + 'px'
    },
    handleDelete: function (row) {
      const payload = {
        systemAccountId: row.id,
        operatorId: this.$route.params.id,
      }
      this.DeleteOperatorAssignee(payload).then(() => {
        if (this.error == null) {
          this.$notify({
            type: 'success',
            message: this.$t('operatorAssignees.manageDialog.actionRemoveSuccess', {
              username: row.username,
              operatorId: this.operatorId
            }),
            icon: 'tim-icons icon-alert-circle-exc'
          })
        }
      });
    },
  },
  watch: {
    tableData() {
      this.$nextTick(this.updateMaxHeight)
    },
  },
  mounted() {
    this.LoadOperatorAssignees(this.$route.params.id)
  },
};
</script>
<style scoped>
.assignees-table {
  overflow-y: auto;
}
</style>
